/**
 * Sort an object alphabetically by its keys
 * @param unordered Any object with string keys
 * @returns An object with the same properies, but sorted alphabetically by its keys
 */
export default <K extends string, V>(unordered: Record<K, V>): Record<K, V> =>
  Object.keys(unordered)
    .sort()
    .reduce<Record<string, unknown>>((obj, key) => {
      const typedKey = key as K;
      obj[typedKey] = unordered[typedKey];
      return obj;
    }, {}) as Record<K, V>;
